module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Heyby-agency","short_name":"HG","start_url":"/","background_color":"#0000","theme_color":"rgba(44,78,174,0.804359243697479)","crossOrigin":"use-credentials","display":"standalone","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"37440022bffaba3a186ec7eb185c99d0"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
